import $ from 'jquery';
import 'slick-carousel';
import { gsap } from "gsap";

const $section     = $('.c-home-slider'),
      $slider      = $section.find('.c-home-slider_slider');

function homeSlider() {	
	
	$slider.slick({
		arrows: true,
		prevArrow: $slider.find('.c-home-slider_arrow--prev'),
		nextArrow: $slider.find('.c-home-slider_arrow--next'),
		dots: true,
		autoplay: true,
		autoplaySpeed: 10000,
		dotsClass: 'c-home-slider_dots',
		rows: 0,
		slide: '.c-home-slider_slide',
		speed: 1000
	});

	$slider.on('afterChange', afterChange);
}

function getSlideElement(index) {
	return $slider.find(`.slick-slide[data-slick-index="${index}"]`);
}

function afterChange(e, slick, currentSlideIndex) {
	var $slide = getSlideElement(currentSlideIndex);
	
	updateAccent($slide);
}

function updateAccent($slide) {
	var accent = $slide[0].style.getPropertyValue('--accent') || '#fff';
	
	$slider[0].style.setProperty('--dots-outline-color', accent);
}


export { homeSlider };